import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { PublicLayout } from "../layouts/PublicLayout";

const HomePage = lazy(() => import("../pages/public/HomePage").then(m => ({ default: m.HomePage })));
const AboutPage = lazy(() => import("../pages/public/AboutPage").then(m => ({ default: m.AboutPage })));
const FeaturesPage = lazy(() => import("../pages/public/FeaturesPage").then(m => ({ default: m.FeaturesPage })));
const ModulesPage = lazy(() => import("../pages/public/ModulesPage").then(m => ({ default: m.ModulesPage })));
const ContactPage = lazy(() => import("../pages/public/ContactPage").then(m => ({ default: m.ContactPage })));
const PrivacyPage = lazy(() => import("../pages/public/PrivacyPage").then(m => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import("../pages/public/TermsPage").then(m => ({ default: m.TermsPage })));
const HelpPage = lazy(() => import("../pages/public/HelpPage").then(m => ({ default: m.HelpPage })));
const StatusPage = lazy(() => import("../pages/public/StatusPage").then(m => ({ default: m.StatusPage })));
const NotFoundPage = lazy(() => import("../pages/public/NotFoundPage").then(m => ({ default: m.NotFoundPage })));
const ServerErrorPage = lazy(() => import("../pages/public/ServerErrorPage").then(m => ({ default: m.ServerErrorPage })));
const OfflinePage = lazy(() => import("../pages/public/OfflinePage").then(m => ({ default: m.OfflinePage })));

export const renderPublicRoutes = () => (
  <Route element={<PublicLayout />}>
    <Route path="/" element={<HomePage />} />
    <Route path="/about" element={<AboutPage />} />
    <Route path="/features" element={<FeaturesPage />} />
    <Route path="/modules" element={<ModulesPage />} />
    <Route path="/contact" element={<ContactPage />} />
    <Route path="/privacy" element={<PrivacyPage />} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/help" element={<HelpPage />} />
    <Route path="/status" element={<StatusPage />} />
    <Route path="/500" element={<ServerErrorPage />} />
    <Route path="/offline" element={<OfflinePage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Route>
);
